const Permissions = {
  ADMIN: 'administrador',
  OPERACIONAL: 'operacional',
  COMERCIAL: 'comercial',
  VENDEDOR: 'vendedor',
};

export default Permissions;
